import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-preloader',
    templateUrl: './preloader.component.html',
    styleUrls: ['./preloader.component.scss'],
    standalone: false
})
export class PreLoaderComponent implements OnInit {
    constructor() { }

    ngOnInit(): void { }
}
